import CloseIcon from "@uui/XClose";

import { IconButton } from "@mui/material";
import { IconButtonProps } from "@mui/material/IconButton";
import styled from "@mui/material/styles/styled";

import LoadSpinner from "@rui/LoadSpinner";
import Stack, { StackProps } from "@rui/Stack";

export const VideoContainer = styled(Stack)({
  position: "relative",
  height: "100%",
  width: "600px",
  aspectRatio: 16 / 9,
  maxWidth: "100%",
});

type AbsolutePositionedProps = StackProps & {
  top?: number;
  bottom?: number;
  right?: number;
  left?: number;
};

export const AbsolutePositioned = styled(
  ({
    top: _top,
    bottom: _bottom,
    left: _left,
    right: _right,
    ...props
  }: AbsolutePositionedProps) => <Stack {...props} />
)(({ top, right, left, bottom }) => ({
  position: "absolute",
  top,
  right,
  left,
  bottom,
}));

export const LoadingOverlay = () => (
  <AbsolutePositioned top={0} right={0} left={0} bottom={0}>
    <Stack variant="center" flex={1}>
      <LoadSpinner />
    </Stack>
  </AbsolutePositioned>
);

export const HtmlVideo = styled("video")({
  width: "100%",
  height: "100%",
  objectFit: "cover",
  objectPosition: "center",
  zIndex: 0,
  backgroundColor: "black",
  "&:hover": {
    cursor: "pointer",
  },
});

export const CloseButton = styled((props: IconButtonProps) => (
  <IconButton size="small" {...props}>
    <CloseIcon />
  </IconButton>
))(({ theme }) => ({
  backgroundColor: theme.palette.transparent.black[20],
  borderRadius: "4px",
  "&:hover": {
    backgroundColor: theme.palette.transparent.black[50],
  },
  "& .MuiSvgIcon-root": {
    color: "#FFF",
  },
}));
